import { useMachine } from "@xstate/react";
import { Popup, Button } from "devextreme-react";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link, useHistory } from "react-router-dom";
import { Machine } from "xstate";
import { api } from "../../../request/api";
import { AuthenticationResponse } from "../../../Types/AuthenticationResponse";
import { saveAuthentication } from "../../../_helpers/token";
import { InputEx } from "../../Inputs/InputEx";
import { InputLabel } from "../../Labels/InputLabel";
import notify from "devextreme/ui/notify";
import { LoadPanelFullScreen } from "../../LoadPanel/LoadPanelFullScreen";


type Props = {
  login?: string;
};

const fetchMachine = Machine({
  id: "loginForm",
  initial: "idle",
  states: {
    idle: {
      on: {
        FETCH: "loading",
      },
    },
    loading: {
      on: {
        RESOLVE: "success",
        REJECT: "failure",
      },
    },
    success: {
      entry: "sigin",
    },
    failure: {
      on: {
        FETCH: "loading",
      },
    },
  },
});

interface IFormInputs {
  password: string;
  passwordConfirmed: string;
  guid: string;
}

const ResetPasswordForm: React.FC<Props> = (login) => {
  const history = useHistory();
  const { register, getValues, handleSubmit, errors } = useForm<IFormInputs>();
  const [loading, setLoading] = useState<boolean>(false);
  const [resetPassword, setResetPassword] = useState();
  const [state, send] = useMachine(fetchMachine, {
    actions: {
      sigin: () => {
        history.push("/");
      },
    },
  });

  const onSubmit = async (formData: IFormInputs) => {
    send("FETCH");
    setLoading(true);
    try {
      await api
        .post("User/ResetPassword", {
          password: formData.password,
          passwordConfirmed: formData.passwordConfirmed,
          guid: window.location.href.substring(window.location.href.lastIndexOf("/") + 1)
        })
        .then((response) => {
          notify(response.data.item1, response.data.item2, 10000);
          setLoading(false);
          //send("RESOLVE");
          localStorage.clear();
          history.push("/");
        });
    } catch (err) {
      setLoading(false);
      notify("Błąd", "error", 5000);
    }
  };

  return (
    <>
      <LoadPanelFullScreen visible={loading} />
      <div className="loginForm">
        <div className="loginWrap">
          <form onSubmit={handleSubmit(onSubmit)} className="align-self-center">
            <div className="loginTitle">Zmiana hasła</div>
            <div className="form-group">
              <div className="passwordInput">
                <InputLabel forHtml="password" message="hasło" />
                <InputEx
                  type="password"
                  placeholder=""
                  name="password"
                  className="form-control"
                  aria-describedby="emailHelp"
                  inputRef={register({
                    required: true,
                  })}
                />

              </div>
              <div className="passwordInput">
                <InputLabel forHtml="passwordConfirmed" message="Powtórz hasło" />
                <InputEx
                  className="form-control"
                  type="password"
                  placeholder=""
                  name="passwordConfirmed"
                  inputRef={register({
                    validate: (value) =>
                      value === getValues("password") || "Hasła muszą być takie same",
                    minLength: {
                      value: 8,
                      message: "Hasło musi mieć co najmniej 8 znaków"
                    },
                    pattern: {
                      value:
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+?&]{8,}$/,
                      message:
                        "Nowe hasło powinno zawierać co najmniej jedną małą literę, dużą literę, znak specjalny oraz cyfrę.",
                    },
                  })}
                  aria-describedby="passwordHelp"
                />

                {/* {errors.password?.type === "required" && (
                  <small id="passwordHelp" className="form-text text-danger">
                    {errors.password.message}
                  </small>
                )} */}
                {errors.passwordConfirmed && (
                  <small id="passwordHelp" className="form-text text-danger">
                    {errors.passwordConfirmed.message}
                  </small>
                )}
              </div>
            </div>

            <InputEx type="submit" className="btn btnSuccess" value="Zmień Hasło" />

          </form>
        </div>
      </div>



    </>
  );
};

export { ResetPasswordForm };
